import { useCallback } from 'react';
import { dayName, monthName } from '@bookingdei/i18n/format-date';
import { localiseDigits } from '@bookingdei/i18n/format-number';
import { useLanguage } from '../../shell/language-context';

// The hero pill's short date ("Tue, Jul 7" / "মঙ্গল, ৭ জুলাই"), built from the
// packages/i18n day and month names; word order is a dictionary template.
export function useDateLabel(): (d: Date) => string {
  const { t, lang } = useLanguage();
  return useCallback(
    (d: Date) =>
      t('dc50.when.date_label', {
        day: dayName(lang, d.getDay()),
        month: monthName(lang, d.getMonth()),
        d: localiseDigits(lang, d.getDate()),
      }),
    [t, lang],
  );
}
